export const OPPORTUNITIES_EN = {
    'nav.module.opportunities': 'Opportunities',
    // ── refusals ──
    'opportunities.refusal.not_found': 'This opportunity is not in this workspace.',
    'opportunities.refusal.not_text': 'This field is text.',
    'opportunities.refusal.too_long': 'This is longer than {max} characters.',
    'opportunities.refusal.owner_module_required': 'Say which module follows this opportunity.',
    'opportunities.refusal.owner_module': 'The module is named by its key.',
    'opportunities.refusal.owner_module_fixed': 'The module that follows an opportunity is set when it is opened.',
    'opportunities.refusal.party_id_required': 'Choose who the opportunity is with.',
    'opportunities.refusal.party_id': 'Choose who the opportunity is with from the list.',
    'opportunities.refusal.owner_id': 'Choose who follows it from the list.',
    'opportunities.refusal.team_ref': 'Choose the team from the list.',
    'opportunities.refusal.branch_ref': 'Choose the branch from the list.',
    'opportunities.refusal.source': 'Choose the source from the list.',
    'opportunities.refusal.subject_ref': 'Choose what is being sold from the list.',
    'opportunities.refusal.stage': 'Choose the stage from the list.',
    'opportunities.refusal.stage_required': 'Choose the stage.',
    'opportunities.refusal.stage_route': 'The stage is moved on its own, not with the other fields.',
    'opportunities.refusal.status_route': 'An opportunity is won, lost or reopened on its own, not with the other fields.',
    'opportunities.refusal.not_owner': 'Only {owner_module} moves this opportunity\'s stage.',
    'opportunities.refusal.amount': 'The amount is a number with at most two decimals, not negative.',
    'opportunities.refusal.currency': 'Choose the currency from the list.',
    'opportunities.refusal.amount_currency': 'An amount is written with its currency.',
    'opportunities.refusal.day': 'Write the date as a day of the calendar.',
    'opportunities.refusal.lost_reason_required': 'Say why it was lost.',
    'opportunities.refusal.closed': 'This opportunity is closed: reopen it first.',
    'opportunities.refusal.open': 'This opportunity is open already.',
    'opportunities.refusal.stale': 'Someone changed this opportunity since you opened it. Open it again to see their change.',
    'opportunities.refusal.version': 'The version is the one the opportunity was read at.',
    'opportunities.refusal.status': 'The status is open, won or lost.',
    'opportunities.refusal.limit': 'Ask for 1 to 500 rows.',
    'opportunities.refusal.ids': 'Name at most 200 opportunities, each by its id.',
    'opportunities.refusal.page': 'Ask for page 1 or later.',
    'opportunities.refusal.size': 'Ask for 1 to {max} rows a page.',
    'opportunities.refusal.sort': 'This list cannot be sorted by that column.',
    'opportunities.refusal.campaign_id': 'Choose the campaign from the list.',
    'opportunities.refusal.campaign_id_required': 'Choose the campaign.',
    'opportunities.refusal.version_required': 'Open the opportunity again before changing its lines.',
    'opportunities.refusal.lines': 'The lines are a list.',
    'opportunities.refusal.lines_too_many': 'An opportunity has at most {max} lines.',
    'opportunities.refusal.line': 'Each line is written in full.',
    'opportunities.refusal.line_description_required': 'Say what each line is.',
    'opportunities.refusal.item_ref': 'Choose what the line sells from the list.',
    'opportunities.refusal.line_quantity': 'The quantity is more than zero, with at most four decimals.',
    'opportunities.refusal.line_unit_price': 'The unit price is a number with at most two decimals, not negative.',
    'opportunities.refusal.line_discount': 'The discount is a percentage from 0 to 100, with at most two decimals.',
    'opportunities.refusal.lines_currency': 'Choose the currency the lines are in.',
    // ── Idempotency-Key, answered by any route that honours it (the SDK's claimOf / onceIn) ──
    'idempotency.refusal.key_shape': 'The request carried a malformed repeat-protection key. Send it again.',
    'idempotency.refusal.reused': 'This request reused the key of a different one. Send it again as a new request.',
    'idempotency.refusal.client_created_at': 'The time this was saved on the device is more than five minutes ahead of now, or more than thirty days ago. Check the device clock, or enter it again.',
    // ── statuses, and what the change record keeps ──
    'opportunities.status.open': 'Open',
    'opportunities.status.won': 'Won',
    'opportunities.status.lost': 'Lost',
    'change.field.opportunity.owner_module': 'Followed by module',
    'change.field.opportunity.party_id': 'Customer',
    'change.field.opportunity.title': 'Title',
    'change.field.opportunity.owner_id': 'Owner',
    'change.field.opportunity.team_ref': 'Team',
    'change.field.opportunity.branch_ref': 'Branch',
    'change.field.opportunity.source': 'Source',
    'change.field.opportunity.status': 'Status',
    'change.field.opportunity.lost_reason': 'Reason lost',
    'change.field.opportunity.amount': 'Expected amount',
    'change.field.opportunity.currency': 'Currency',
    'change.field.opportunity.expected_close_on': 'Expected close',
    'change.field.opportunity.subject_ref': 'Subject',
    'change.field.opportunity.stage': 'Stage',
    'change.field.opportunity.stage_changed_at': 'Stage changed',
    'change.field.opportunity.closed_at': 'Closed',
    'change.field.opportunity.closed_by': 'Closed by',
    'change.field.opportunity.created_by': 'Opened by',
    'change.field.opportunity.campaign_id': 'Campaign',
    'change.field.opportunity.line_no': 'Line',
    'change.field.opportunity.item_ref': 'Item',
    'change.field.opportunity.description': 'Line description',
    'change.field.opportunity.quantity': 'Quantity',
    'change.field.opportunity.unit_price': 'Unit price',
    'change.field.opportunity.discount_pct': 'Discount %',
    // ── the lines tab and editor, and what came of a campaign ──
    'entity.opportunities.opportunity': 'The opportunity',
    'opportunities.refusal.amount_from_lines': 'While the opportunity has lines, its value is their sum: change the lines.',
    'opportunities.opportunity_lines.title': 'Lines',
    'opportunities.opportunity_lines.sum': 'The opportunity\'s value',
    'opportunities.opportunity_lines.note': 'While there are lines, the opportunity\'s value is their sum and is changed through them.',
    'opportunities.opportunity_lines.empty': 'No lines yet: the value is written by hand until the first line.',
    'opportunities.action.edit_lines': 'Edit lines',
    'opportunities.col.line_no': 'Line',
    'opportunities.col.description': 'Description',
    'opportunities.col.quantity': 'Quantity',
    'opportunities.col.unit_price': 'Unit price',
    'opportunities.col.discount_pct': 'Discount %',
    'opportunities.col.amount': 'Amount',
    'opportunities.col.title': 'Opportunity',
    'opportunities.col.party': 'Customer',
    'opportunities.col.value': 'Value',
    'opportunities.col.expected_close_on': 'Expected close',
    'opportunities.col.status': 'Status',
    'opportunities.col.currency': 'Currency',
    'opportunities.col.id': 'Id',
    'opportunities.campaign_figures.title': 'What came of it',
    'opportunities.campaign_figures.total': 'Opportunities',
    'opportunities.campaign_figures.total.second': '{open} open',
    'opportunities.campaign_figures.won': 'Won',
    'opportunities.campaign_figures.won.second': '{lost} lost',
    'opportunities.campaign_figures.won_value': 'Won value',
    'opportunities.campaign_figures.open': 'Open',
    'opportunities.campaign_figures.lost': 'Lost',
    'opportunities.campaign_opportunities.title': 'Opportunities',
    'opportunities.campaign_opportunities.empty': 'No opportunity names this campaign yet.',
    'opportunities.lines.title': 'Opportunity lines',
    'opportunities.lines.lede': 'What the opportunity is for, line by line; while it has lines, its value is their sum.',
    'opportunities.lines.for': 'Lines of «{title}»',
    'opportunities.lines.untitled': 'Lines of the opportunity',
    'opportunities.lines.no_id': 'Open the lines from an opportunity.',
    'opportunities.lines.add': 'Add a line',
    'opportunities.lines.remove': 'Remove the line',
    'opportunities.lines.total': 'The opportunity\'s value',
    'opportunities.lines.currency': 'Currency',
    'opportunities.lines.currency.help': 'The opportunity has no currency yet: the lines set it.',
    'opportunities.lines.save': 'Save the lines',
    'opportunities.lines.saved': 'The lines are saved; the opportunity\'s value is their sum.',
    'opportunities.lines.none': 'Removing every line leaves the value as it is, to be written by hand.',
};
export const OPPORTUNITIES_AR = {
    'nav.module.opportunities': 'الفرص',
    // ── refusals ──
    'opportunities.refusal.not_found': 'هذه الفرصة ليست في مساحة العمل هذه.',
    'opportunities.refusal.not_text': 'هذا الحقل نص.',
    'opportunities.refusal.too_long': 'هذا أطول من {max} حرفاً.',
    'opportunities.refusal.owner_module_required': 'حدّد الوحدة التي تتابع هذه الفرصة.',
    'opportunities.refusal.owner_module': 'تُسمّى الوحدة بمفتاحها.',
    'opportunities.refusal.owner_module_fixed': 'الوحدة التي تتابع الفرصة تُحدَّد عند فتحها.',
    'opportunities.refusal.party_id_required': 'اختر العميل الذي تخصّه الفرصة.',
    'opportunities.refusal.party_id': 'اختر العميل من القائمة.',
    'opportunities.refusal.owner_id': 'اختر المسؤول عن المتابعة من القائمة.',
    'opportunities.refusal.team_ref': 'اختر الفريق من القائمة.',
    'opportunities.refusal.branch_ref': 'اختر الفرع من القائمة.',
    'opportunities.refusal.source': 'اختر المصدر من القائمة.',
    'opportunities.refusal.subject_ref': 'اختر محلّ البيع من القائمة.',
    'opportunities.refusal.stage': 'اختر المرحلة من القائمة.',
    'opportunities.refusal.stage_required': 'اختر المرحلة.',
    'opportunities.refusal.stage_route': 'تُنقل المرحلة وحدها، لا مع بقية الحقول.',
    'opportunities.refusal.status_route': 'تُكسب الفرصة أو تُخسر أو يُعاد فتحها بإجراء مستقل، لا مع بقية الحقول.',
    'opportunities.refusal.not_owner': 'لا ينقل مرحلة هذه الفرصة إلا {owner_module}.',
    'opportunities.refusal.amount': 'المبلغ رقم بخانتين عشريتين على الأكثر، وليس سالباً.',
    'opportunities.refusal.currency': 'اختر العملة من القائمة.',
    'opportunities.refusal.amount_currency': 'يُكتب المبلغ مع عملته.',
    'opportunities.refusal.day': 'اكتب التاريخ يوماً من التقويم.',
    'opportunities.refusal.lost_reason_required': 'اذكر سبب الخسارة.',
    'opportunities.refusal.closed': 'هذه الفرصة مغلقة: أعد فتحها أولاً.',
    'opportunities.refusal.open': 'هذه الفرصة مفتوحة أصلاً.',
    'opportunities.refusal.stale': 'غيّر أحدهم هذه الفرصة بعد أن فتحتها. افتحها من جديد لترى تغييره.',
    'opportunities.refusal.version': 'الإصدار هو الذي قُرئت عليه الفرصة.',
    'opportunities.refusal.status': 'الحالة مفتوحة أو مكسوبة أو خاسرة.',
    'opportunities.refusal.limit': 'اطلب من 1 إلى 500 صف.',
    'opportunities.refusal.ids': 'اذكر 200 فرصة على الأكثر، كلًّا بمعرّفها.',
    'opportunities.refusal.page': 'اطلب الصفحة 1 أو ما بعدها.',
    'opportunities.refusal.size': 'اطلب من 1 إلى {max} صفاً في الصفحة.',
    'opportunities.refusal.sort': 'لا تُرتَّب هذه القائمة بهذا العمود.',
    'opportunities.refusal.campaign_id': 'اختر الحملة من القائمة.',
    'opportunities.refusal.campaign_id_required': 'اختر الحملة.',
    'opportunities.refusal.version_required': 'افتح الفرصة من جديد قبل تغيير بنودها.',
    'opportunities.refusal.lines': 'البنود قائمة.',
    'opportunities.refusal.lines_too_many': 'للفرصة {max} بنداً على الأكثر.',
    'opportunities.refusal.line': 'يُكتب كل بند كاملاً.',
    'opportunities.refusal.line_description_required': 'اذكر ما كل بند.',
    'opportunities.refusal.item_ref': 'اختر ما يبيعه البند من القائمة.',
    'opportunities.refusal.line_quantity': 'الكمية أكبر من صفر، بأربع خانات عشرية على الأكثر.',
    'opportunities.refusal.line_unit_price': 'سعر الوحدة رقم بخانتين عشريتين على الأكثر، وليس سالباً.',
    'opportunities.refusal.line_discount': 'الخصم نسبة من 0 إلى 100، بخانتين عشريتين على الأكثر.',
    'opportunities.refusal.lines_currency': 'اختر العملة التي كُتبت بها البنود.',
    // ── Idempotency-Key, answered by any route that honours it (the SDK's claimOf / onceIn) ──
    'idempotency.refusal.key_shape': 'حمل الطلب مفتاح منع تكرار غير صالح. أرسله مرة أخرى.',
    'idempotency.refusal.reused': 'استعمل هذا الطلب مفتاح طلب آخر. أرسله من جديد طلباً جديداً.',
    'idempotency.refusal.client_created_at': 'وقت حفظه على الجهاز يسبق الآن بأكثر من خمس دقائق، أو مضى عليه أكثر من ثلاثين يوماً. تحقّق من ساعة الجهاز، أو أدخله من جديد.',
    // ── statuses, and what the change record keeps ──
    'opportunities.status.open': 'مفتوحة',
    'opportunities.status.won': 'مكسوبة',
    'opportunities.status.lost': 'خاسرة',
    'change.field.opportunity.owner_module': 'الوحدة المتابِعة',
    'change.field.opportunity.party_id': 'العميل',
    'change.field.opportunity.title': 'العنوان',
    'change.field.opportunity.owner_id': 'المسؤول',
    'change.field.opportunity.team_ref': 'الفريق',
    'change.field.opportunity.branch_ref': 'الفرع',
    'change.field.opportunity.source': 'المصدر',
    'change.field.opportunity.status': 'الحالة',
    'change.field.opportunity.lost_reason': 'سبب الخسارة',
    'change.field.opportunity.amount': 'المبلغ المتوقع',
    'change.field.opportunity.currency': 'العملة',
    'change.field.opportunity.expected_close_on': 'الإغلاق المتوقع',
    'change.field.opportunity.subject_ref': 'محلّ البيع',
    'change.field.opportunity.stage': 'المرحلة',
    'change.field.opportunity.stage_changed_at': 'تغيّر المرحلة',
    'change.field.opportunity.closed_at': 'أُغلقت',
    'change.field.opportunity.closed_by': 'أغلقها',
    'change.field.opportunity.created_by': 'فتحها',
    'change.field.opportunity.campaign_id': 'الحملة',
    'change.field.opportunity.line_no': 'البند',
    'change.field.opportunity.item_ref': 'الصنف',
    'change.field.opportunity.description': 'وصف البند',
    'change.field.opportunity.quantity': 'الكمية',
    'change.field.opportunity.unit_price': 'سعر الوحدة',
    'change.field.opportunity.discount_pct': 'الخصم ٪',
    // ── the lines tab and editor, and what came of a campaign ──
    'entity.opportunities.opportunity': 'الفرصة',
    'opportunities.refusal.amount_from_lines': 'ما دامت للفرصة بنود فقيمتها مجموعها: عدّل البنود.',
    'opportunities.opportunity_lines.title': 'البنود',
    'opportunities.opportunity_lines.sum': 'قيمة الفرصة',
    'opportunities.opportunity_lines.note': 'ما دامت للفرصة بنود فقيمتها مجموعها، وتُعدَّل من البنود.',
    'opportunities.opportunity_lines.empty': 'لا بنود بعد: تُكتب القيمة يدوياً حتى أول بند.',
    'opportunities.action.edit_lines': 'عدّل البنود',
    'opportunities.col.line_no': 'البند',
    'opportunities.col.description': 'الوصف',
    'opportunities.col.quantity': 'الكمية',
    'opportunities.col.unit_price': 'سعر الوحدة',
    'opportunities.col.discount_pct': 'الخصم ٪',
    'opportunities.col.amount': 'المبلغ',
    'opportunities.col.title': 'الفرصة',
    'opportunities.col.party': 'العميل',
    'opportunities.col.value': 'القيمة',
    'opportunities.col.expected_close_on': 'الإغلاق المتوقّع',
    'opportunities.col.status': 'الحالة',
    'opportunities.col.currency': 'العملة',
    'opportunities.col.id': 'المعرّف',
    'opportunities.campaign_figures.title': 'ما نتج عنها',
    'opportunities.campaign_figures.total': 'الفرص',
    'opportunities.campaign_figures.total.second': '{open} مفتوحة',
    'opportunities.campaign_figures.won': 'المكسوبة',
    'opportunities.campaign_figures.won.second': '{lost} خاسرة',
    'opportunities.campaign_figures.won_value': 'قيمة المكسوب',
    'opportunities.campaign_figures.open': 'المفتوحة',
    'opportunities.campaign_figures.lost': 'الخاسرة',
    'opportunities.campaign_opportunities.title': 'الفرص',
    'opportunities.campaign_opportunities.empty': 'لا فرصة تذكر هذه الحملة بعد.',
    'opportunities.lines.title': 'بنود الفرصة',
    'opportunities.lines.lede': 'ما الفرصة عنه بنداً بنداً؛ ما دامت لها بنود فقيمتها مجموعها.',
    'opportunities.lines.for': 'بنود «{title}»',
    'opportunities.lines.untitled': 'بنود الفرصة',
    'opportunities.lines.no_id': 'افتح البنود من فرصة.',
    'opportunities.lines.add': 'أضف بنداً',
    'opportunities.lines.remove': 'احذف البند',
    'opportunities.lines.total': 'قيمة الفرصة',
    'opportunities.lines.currency': 'العملة',
    'opportunities.lines.currency.help': 'لا عملة للفرصة بعد: تحدّدها البنود.',
    'opportunities.lines.save': 'احفظ البنود',
    'opportunities.lines.saved': 'حُفظت البنود؛ قيمة الفرصة مجموعها.',
    'opportunities.lines.none': 'حذف كل البنود يُبقي القيمة كما هي، لتُكتب يدوياً.',
};
//# sourceMappingURL=i18n-opportunities.js.map